import React, { useState, useEffect, useCallback, useMemo } from 'react';
const MetricaCard = ({ config, className, onResultChange, calculatedR1 = null, calculatedR2 = null }) => {
const initialInputs = config.inputs.reduce((acc, input) => {
acc[input.name] = '';
return acc;
}, {});
const [inputs, setInputs] = useState(initialInputs);
const [resultados, setResultados] = useState({ r1: null, r2: null, r3: null, r1_raw_num: null });
const handleInputChange = (e) => {
const { name, value } = e.target;
const regex = /^-?\d*\.?\d*$/; 
if (value === '' || regex.test(value)) {
setInputs(prevInputs => ({
...prevInputs,
[name]: value,
}));
}
};
useEffect(() => {
const values = config.inputs.map(input => ({
name: input.name,
value: parseFloat(inputs[input.name])
}));
const allFilledAndValid = values.every(v => inputs[v.name] !== '' && !isNaN(v.value));
if (config.id === 'cicloConversionCaja') {
    if (onResultChange) {
        const ventasAnualesValue = values.find(v => v.name === 'a')?.value;
        const isVentasAnualesValid = inputs['a'] !== '' && !isNaN(ventasAnualesValue);
        onResultChange(config.id, isVentasAnualesValid ? ventasAnualesValue : null);
    }
} else {
    if (allFilledAndValid) {
        const args = values.map(v => v.value);
        const calculatedResults = config.calculate(...args); 
        setResultados(calculatedResults);
        if (onResultChange) {
            onResultChange(config.id, calculatedResults.r1_raw_num);
        }
    } else {
        setResultados({ r1: null, r2: null, r3: null, r1_raw_num: null });
        if (onResultChange) {
            onResultChange(config.id, null);
        }
    }
}
}, [inputs, config, onResultChange]);
const displayR1 = config.id === 'cicloConversionCaja' ? calculatedR1 : resultados.r1;
const displayR2 = config.id === 'cicloConversionCaja' ? calculatedR2 : resultados.r2;
const renderR1Input = () => (
    <div className="resultado-input-group" key="r1-group">
        <label>{config.resultado1Label}</label>
        <div className="input-group" >
            <input
                type="text"
                className="input"
                style={{border:'1px solid #e65c5c;'}}
                value={displayR1 !== null ? displayR1 : ''}
                placeholder={displayR1 === 'División por Cero' || displayR1 === 'Indefinido (R₁ = 0)' || displayR1 === '' ? displayR1 : ''}
                disabled 
            />
            <span className='unit'>{config.unitR1}</span>
        </div>
    </div>
);
const renderR2Input = () => (
    config.resultado2Label && (
        <div className="resultado-input-group resultado-secundario" key="r2-group">
            <label>{config.resultado2Label}</label>
            <div className="input-group">
                <input
                    type="text"
                    style={{border:'1px solid #  border: 1px solid #e65c5c;'}}
                    className="input"
                    value={displayR2 !== null && displayR2 !== 'División por Cero (R₃)' ? displayR2 : ''}
                    placeholder={displayR2 === 'Indefinido (R₁ = 0)' || displayR2 === 'División por Cero (R₃)' || displayR2 === '' ? displayR2 : ''}
                    disabled
                /><span className='unit'>{config.unitR2}</span>
            </div>
        </div>
    )
);
const renderUserInputs = () => (
    config.inputs && config.inputs.map((input) => {
        const isLongPlaceholder = input.placeholder === 'Beneficio antes de intereses, impuestos, depreciación y amortización';
        const inputRows = isLongPlaceholder && inputs[input.name] === '' ? 2 : 1;
        return (
            <div className="input-group" key={input.name}>
                <input
                    id={input.name}
                    type="text" 
                    name={input.name}
                    className={`input ${input.placeholder === 'Beneficio antes de intereses, impuestos, depreciación y amortización' ? 'placeholder-pequeno' : ''}`}
                    value={inputs[input.name]}
                    onChange={handleInputChange}
                    placeholder={input.placeholder}
                />{input.unit && <span className='unit'>{input.unit}</span>}
            </div>
        );
    })
);
return (
<div className={`metrica-card ${className}`}>
<h3>{config.title}</h3>
{}
{config.id === 'cicloConversionCaja' ? (
    <>
        {}
        <div className="resultado-box">
            <div className="resultados-grupo">
                {renderR1Input()}
            </div>
        </div>
        {}
        {renderUserInputs()}
        {}
        <div className="resultado-box">
            <div className="resultados-grupo">
                {renderR2Input()}
            </div>
        </div>
    </>
) : (
    <>
        {renderUserInputs()}
        <div className="resultado-box">
            <div className="resultados-grupo">
                {renderR1Input()}
                {config.hasSeparatorH3 && <h3 style={{marginTop: '20px', marginBottom: '10px'}}>{config.hasSeparatorH3}</h3>}
                {renderR2Input()}
                {config.resultado3Label && (
                    <div className="resultado-input-group resultado-secundario" key="r3-group">
                        <label>{config.resultado3Label}</label>
                        <div className="input-group">
                            <input
                                type="text"
                                style={{border:'1px solid #  border: 1px solid #e65c5c;'}}
                                className="input"
                                value={resultados.r3 !== null ? resultados.r3 : ''}
                                placeholder={resultados.r3 === 'División por Cero' ? resultados.r3 : ''}
                                disabled
                            />
                            <span className='unit'>{config.unitR3}</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    </>
)}
</div>
);
};
const METRICAS_CONFIG = [
{
id: 'diasInventario',
title: 'Días de inventario',
formulaDisplay: '((A+B)/2)/C',
inputs: [
{ name: 'a', label: 'Valor A', placeholder: 'Valor del inventario al inicio del periodo', unit: '$' },
{ name: 'b', label: 'Valor B', placeholder: 'Valor del inventario al final del periodo', unit: '$' },
{ name: 'c', label: 'Valor C', placeholder: 'Costo de los bienes vendidos del periodo', unit: '$' },
],
calculate: (a, b, c) => {
if (c === 0) return { r1: 'División por Cero', r2: null, r1_raw_num: null };
const r1_raw = ((a + b) / 2) / c;
const r1 = Math.round(r1_raw);
const r2_raw = (r1_raw !== 0) ? (360 / r1_raw) : 'Indefinido (R₁ = 0)';
const r2 = typeof r2_raw === 'number' ? Math.round(r2_raw) : r2_raw;
return { 
r1: r1.toString(), 
r2: typeof r2 === 'number' ? r2.toString() : r2,
r1_raw_num: r1_raw
};
},
resultado1Label: 'Resultado (en días)',
unitR1: 'D',
resultado2Label: 'Resultado (en veces al año)',
unitR2: 'V',
hasSeparatorH3: 'Rotación del inventario'
},
{
id: 'cicloVenta',
title: 'Ciclo de venta',
formulaDisplay: 'A / (B/360)',
inputs: [
{ name: 'a', label: 'Valor A', placeholder: 'Cuentas por cobrar al final del periodo', unit: '$' },
{ name: 'b', label: 'Valor B', placeholder: 'Ventas del periodo', unit: '$' },
],
calculate: (a, b) => {
const b360 = b / 360;
if (b360 === 0) return { r1: 'División por Cero', r2: null, r1_raw_num: null };
const r1_raw = a / b360; 
const r1 = Math.round(r1_raw);
const r2_raw = (r1_raw !== 0) ? (360 / r1_raw) : 'Indefinido (R₁ = 0)';
const r2 = typeof r2_raw === 'number' ? Math.round(r2_raw) : r2_raw;
return { 
r1: r1.toString(), 
r2: typeof r2 === 'number' ? r2.toString() : r2,
r1_raw_num: r1_raw
};
},
resultado1Label: 'Resultado (en días)',
unitR1: 'D',
},
{
id: 'ciclosPago',
title: 'Ciclos de pago',
formulaDisplay: 'A / (B/360)',
inputs: [
{ name: 'a', label: 'Valor A', placeholder: 'Cuentas por pagar al final del periodo', unit: '$' },
{ name: 'b', label: 'Valor B', placeholder: 'Costo de los bienes vendidos del periodo', unit: '$' },
],
calculate: (a, b) => {
const b360 = b / 360;
if (b360 === 0) return { r1: 'División por Cero', r2: null, r1_raw_num: null };
const r1_raw = a / b360; 
const r1 = Math.round(r1_raw);
const r2_raw = (r1_raw !== 0) ? (360 / r1_raw) : 'Indefinido (R₁ = 0)';
const r2 = typeof r2_raw === 'number' ? Math.round(r2_raw) : r2_raw;
return { 
r1: r1.toString(), 
r2: typeof r2 === 'number' ? r2.toString() : r2,
r1_raw_num: r1_raw
};
},
resultado1Label: 'Resultado (en días)',
unitR1: 'D',
},
{
id: 'rotacionActivoFijo',
title: 'Rotación del activo fijo',
formulaDisplay: 'A / B',
inputs: [
{ name: 'a', label: 'Valor A', placeholder: 'Ventas del periodo', unit: '$' },
{ name: 'b', label: 'Valor B', placeholder: 'Valor total del activo fijo', unit: '$' },
],
calculate: (a, b) => {
if (b === 0) return { r1: 'División por Cero', r2: null };
const r1_raw = a / b;
const r1 = Math.round(r1_raw);
return { 
r1: r1.toString(), 
r2: null 
};
},
resultado1Label: 'Resultado (en $)',
unitR1: '$',
},
{
id: 'rotacionActivoTotal',
title: 'Rotación del activo total',
formulaDisplay: 'A / B',
inputs: [
{ name: 'a', label: 'Valor A', placeholder: 'Ventas del periodo', unit: '$' },
{ name: 'b', label: 'Valor B', placeholder: 'Valor del activo total', unit: '$' },
],
calculate: (a, b) => {
if (b === 0) return { r1: 'División por Cero', r2: null };
const r1_raw = a / b;
const r1 = Math.round(r1_raw);
return { 
r1: r1.toString(), 
r2: null 
};
},
resultado1Label: 'Resultado (en $)',
unitR1: '$',
},
{
id: 'alzaCaidaVentas',
title: 'Alza (caída) de las ventas anuales',
formulaDisplay: '((A/B)-1)*100',
inputs: [
{ name: 'a', label: 'Valor A', placeholder: 'Ventas del periodo anterior', unit: '$' },
{ name: 'b', label: 'Valor B', placeholder: 'Ventas del periodo Actual', unit: '$' },
],
calculate: (a, b) => {
if (b === 0) return { r1: 'División por Cero', r2: null };
const r1_raw = ((a / b) - 1) * 100;
const r1 = Math.round(r1_raw);
return { 
r1: r1.toString(), 
r2: null 
};
},
resultado1Label: 'Resultado (en %)',
unitR1: '%',
},
{
id: 'flujoCajaLibre',
title: 'Flujo de caja libre',
formulaDisplay: 'A - B',
inputs: [
{ name: 'a', label: 'Valor A', placeholder: 'Beneficio operativo del periodo actual', unit: '$' },
{ name: 'b', label: 'Valor B', placeholder: 'Gastos de inversión del periodo actual', unit: '$' },
],
calculate: (a, b) => {
const r1_raw = a - b;
const r1 = Math.round(r1_raw);
return { 
r1: r1.toString(), 
r2: null 
};
},
resultado1Label: 'Resultado (en $)',
unitR1: '$',
},
{
id: 'retornoCapitalSocial',
title: 'Retorno sobre el capital social',
formulaDisplay: '((A / B) - 1) * 100',
inputs: [
{ name: 'a', label: 'Valor A', placeholder: 'Beneficio operativo del periodo actual', unit: '$' },
{ name: 'b', label: 'Valor B', placeholder: 'Valor del capital social del periodo actual', unit: '$' },
],
calculate: (a, b) => {
if (b === 0) return { r1: 'División por Cero', r2: null };
const r1_raw = ((a / b) - 1) * 100;
const r1 = Math.round(r1_raw);
return { 
r1: r1.toString(), 
r2: null 
};
},
resultado1Label: 'Resultado (en %)',
unitR1: '%',
},
{
id: 'beneficioNetoPorParticipacion',
title: 'Beneficio neto por participación',
formulaDisplay: 'A / B',
inputs: [
{ name: 'a', label: 'Valor A', placeholder: 'Beneficio neto del periodo actual', unit: '$' },
{ name: 'b', label: 'Valor B', placeholder: 'Total de participaciones sociales', unit: 'U' },
],
calculate: (a, b) => {
if (b === 0) return { r1: 'División por Cero', r2: null };
const r1_raw = a / b;
const r1 = Math.round(r1_raw);
return { 
r1: r1.toString(), 
r2: null 
};
},
resultado1Label: 'Resultado (en $)',
unitR1: '$',
},
{
id: 'conversionCaja',
title: 'Conversión de Caja',
formulaDisplay: '(A / B) * 100',
inputs: [
{ name: 'a', label: 'Valor A', placeholder: 'Beneficio operativo del periodo actual', unit: '$' },
{ name: 'b', label: 'Valor B', placeholder: 'Beneficio antes de intereses, impuestos, depreciación y amortización', unit: '$' },
],
calculate: (a, b) => {
if (b === 0) return { r1: 'División por Cero', r2: null };
const r1_raw = (a / b) * 100;
const r1 = Math.round(r1_raw);
return { 
r1: r1.toString(), 
r2: null 
};
},
resultado1Label: 'Conversión de Caja (%)',
unitR1: '%',
},
{
id: 'roic',
title: 'Retorno sobre el capital invertido',
formulaDisplay: '((A / (B + C)) - 1) * 100',
inputs: [
{ name: 'a', label: 'Valor A', placeholder: 'Beneficio operativo del periodo actual', unit: '$' },
{ name: 'b', label: 'Valor B', placeholder: 'Valor del capital social del periodo actual', unit: '$' },
{ name: 'c', label: 'Valor C', placeholder: 'Deuda neta (Deuda total - caja)', unit: '$' },
],
calculate: (a, b, c) => {
const capitalInvertido = b + c;
if (capitalInvertido === 0) return { r1: 'División por Cero', r2: null };
const r1_raw = ((a / capitalInvertido) - 1) * 100;
const r1 = Math.round(r1_raw);
return { 
r1: r1.toString(), 
r2: null 
};
},
resultado1Label: 'Resultado (en %)',
unitR1: '%',
},
{
id: 'valorPresenteDinero',
title: 'Valor Presente Neto',
formulaDisplay: 'F = Σ [B / (1 + C/100)^t], R₂=F-A, R₃=F/A',
inputs: [
{ name: 'a', label: 'Valor A', placeholder: 'Cifra de dinero a invertir', unit: '$' },
{ name: 'b', label: 'Valor B', placeholder: 'Retorno anual de la inversión', unit: '$' },
{ name: 'c', label: 'Valor C', placeholder: 'Tasa de descuento', unit: '%' },
{ name: 'd', label: 'Valor D', placeholder: 'Cantidad de años', unit: 'A' },
],
calculate: (a, b, c, d) => {
if (c <= 0) return { r1: 'Error: Tasa de descuento debe ser positiva', r2: null, r3: null };
if (!Number.isInteger(d) || d <= 0) return { r1: 'Error: Años debe ser un entero positivo', r2: null, r3: null }; 
let valorPresenteTotal = 0;
const tasaDecimal = c / 100;
for (let t = 1; t <= d; t++) {
valorPresenteTotal += b / Math.pow(1 + tasaDecimal, t);
}
const F = valorPresenteTotal;
const R2_raw = F; 
const R2 = Math.round(R2_raw);
const R1_raw = F - a;
const R1 = Math.round(R1_raw); 
let R3_result = null;
if (a === 0) {
R3_result = 'División por Cero';
} else {
const R3_raw = F / a;
R3_result = R3_raw.toFixed(2); 
}
return { 
r1: R1.toString(),
r2: R2.toString(),
r3: R3_result
};
},
resultado1Label: 'Resultado Neto (en $)',
unitR1: '$',
resultado2Label: 'Valor presente (en $)',
unitR2: '$',
resultado3Label: 'Índice de rentabilidad (en $)',
unitR3: '$',
}
];
const Metricas = () => {
    const [dependentResults, setDependentResults] = useState({
        diasInventario: null,
        cicloVenta: null,
        ciclosPago: null,
        cicloConversionCaja: null, 
    });
    
    // Handler memorizado
    const handleDependentResultChange = useCallback((id, value) => {
        setDependentResults(prev => ({
            ...prev,
            [id]: value
        }));
    }, []);

    // --- CONFIGURACIONES MEMORIZADAS (¡La clave para el rendimiento y la estabilidad!) ---
    
    const metrica1 = METRICAS_CONFIG[0]; // Referencia estática
    const metricaGrupo23 = useMemo(() => METRICAS_CONFIG.slice(1, 3), []);
    const metricaGrupo45 = useMemo(() => METRICAS_CONFIG.slice(3, 5), []);
    const metricaGrupoInferior = useMemo(() => METRICAS_CONFIG.slice(5, 11), []);
    const metricaFinalVPN = useMemo(() => METRICAS_CONFIG.find(m => m.id === 'valorPresenteDinero'), []);
    
    // Objeto creado inline, memorizado correctamente
    const metricaFinalConversionCajaConfig = useMemo(() => ({
        id: 'cicloConversionCaja',
        title: 'Ciclo de conversión de caja',
        formulaDisplay: 'R1 = (Días Inventario + Ciclo Venta - Ciclos Pago) | R2 = R1 * (A / 360)',
        inputs: [
            { name: 'a', label: 'Cifra de ventas anuales', placeholder: 'Cifra de ventas anuales', unit: '$' }, 
        ],
        resultado1Label: 'Resultado (en días)',
        unitR1: 'D',
        resultado2Label: 'Capital de trabajo requerido (en $)',
        unitR2: '$',
        hasSeparatorH3: null
    }), []); // Dependencias vacías: se crea solo una vez.
    
    // --- Lógica de cálculo (permanece igual) ---
    const { diasInventario, cicloVenta, ciclosPago, cicloConversionCaja: ventasAnuales } = dependentResults;
    const dependentValues = [diasInventario, cicloVenta, ciclosPago];
    const allValidR1 = dependentValues.every(val => typeof val === 'number' && !isNaN(val) && val !== null);
    
    let R1_conversion_dias_raw = null;
    let R1_conversion_dias_display = null;
    let R2_necesidad_financiamiento_display = null;
    
    if (allValidR1) {
        R1_conversion_dias_raw = diasInventario + cicloVenta - ciclosPago;
        R1_conversion_dias_display = Math.round(R1_conversion_dias_raw).toString();
        
        if (typeof ventasAnuales === 'number' && !isNaN(ventasAnuales) && ventasAnuales !== null) {
            if (ventasAnuales === 0) {
                R2_necesidad_financiamiento_display = 'División por Cero';
            } else {
                const r2_raw = R1_conversion_dias_raw * (ventasAnuales / 360);
                R2_necesidad_financiamiento_display = Math.round(r2_raw).toString();
            }
        } else {
            R2_necesidad_financiamiento_display = '';
        }
    } else {
        R1_conversion_dias_display = ''; 
        R2_necesidad_financiamiento_display = ''; 
    }

    return (
        <div className="Trazabilidad">
            <header className="trazabilidad-header">
                <div className="header-content">
                    <h1>Métricas</h1>
                </div>
            </header>
            <div className="trazabilidad-content" style={{padding:'10px 10px 70px'}}>
                <div className="metricas-grid">
                    {/* RESTAURADA LA POSICIÓN DE LA PRIMERA METRICA */}
                    <MetricaCard 
                        key={metrica1.id} 
                        config={metrica1} 
                        className={'span-rows'}
                        onResultChange={handleDependentResultChange}
                    />
                    <div className="metricas-stack">
                        {metricaGrupo23.map((metrica) => (
                            <MetricaCard 
                                key={metrica.id} 
                                config={metrica} 
                                onResultChange={handleDependentResultChange}
                            />
                        ))}
                    </div>
                    <div className="metricas-stack">
                        {metricaGrupo45.map((metrica) => (
                            <MetricaCard key={metrica.id} config={metrica} />
                        ))}
                    </div>
                </div>
                <hr className="divider" />
                <div className="metricas-grid-inferior">
                    {metricaGrupoInferior.map((metrica) => (
                        <MetricaCard key={metrica.id} config={metrica} />
                    ))}
                </div>
                <hr className="divider" style={{marginTop:'30px'}} />
                <div className="metricas-grid-final">
                    {/* PRIMERO: Valor Presente Neto */}
                    <MetricaCard key={metricaFinalVPN.id} config={metricaFinalVPN} />
                    
                    {/* SEGUNDO: Ciclo de Conversión de Caja (CORREGIDO EL NOMBRE DE LA VARIABLE) */}
                    <MetricaCard 
                        key={metricaFinalConversionCajaConfig.id} 
                        config={metricaFinalConversionCajaConfig} // <--- ¡CORREGIDO!
                        onResultChange={handleDependentResultChange}
                        calculatedR1={R1_conversion_dias_display}
                        calculatedR2={R2_necesidad_financiamiento_display}
                    />
                </div>
            </div>
        </div>
    );
};
export default Metricas;